<!-- pc端页面 -->
<template>
  <!--页面主体部分-->
  <div class="component_box">
    <!-- 商品导航组件、效验组件、dispalySort为1的组件不进行渲染 -->
    <template v-if="version==='1'">
      <template v-for="(item,index) in list">
        <vue-lazy-component :key="index" threshold="50px">
          <component
            v-show="item.commonConf ? (item.commonConf[0].comShow ? !item.commonConf[0].comShow :true) : true"
            :key="index"
            :is="item.bannerType"
            :item="item"
            :firstId="firstId"
            :formConfig="formConfig"
            :form="form"
          ></component>
        </vue-lazy-component>
      </template>
    </template>
    <cus-widge
      :firstId="firstId"
      :pageData="pageData"
      :list="list"
      v-else-if="version==='2'"
      :formConfig="formConfig"
      :form="form"
    ></cus-widge>
  </div>
</template>

<script>
//这里可以导入其它文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》from ‘《组件路径》';
import CusWidge from './cusWidge.vue'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { CusWidge },
  props: {
    pageData: {
      type: [Object, Array],
    },
    version: {
      type: String,
    },
    firstId: {
      type: String,
    },
    formConfig: {
      type: Object,
      default: () => {},
    },
    list:{
      type: Array,
      default:()=>[]
    }
  },
  data() {
    //这里存放数据
    return {
      form: {},
    };
  },
  //计算属性 类似于data概念
  computed: {},
  //监控data中数据变化
  watch: {
  },
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  //生命周期-创建之前
  beforeCreated() {},
  //生命周期-挂载之前
  beforeMount() {},
  //生命周期-更新之前
  beforUpdate() {},
  //生命周期-更新之后
  updated() {},
  //生命周期-销毁之前
  beforeDestory() {},
  //生命周期-销毁完成
  destoryed() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
}
</script>
<style lang='scss' scoped>
/* @import url(); 引入css类 */
</style>